import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_ENV_FIREBASE_APIKEY,
    authDomain: process.env.REACT_APP_ENV_FIREBASE_AUTHDOMAIN,
    projectId: process.env.REACT_APP_ENV_FIREBASE_PROJECTID,
    storageBucket: process.env.REACT_APP_ENV_FIREBASE_STORAGEBUCKET,
    messagingSenderId: process.env.REACT_APP_ENV_FIREBASE_MESSAGINGSENDERID,
    appId: process.env.REACT_APP_ENV_FIREBASE_APPID,
    measurementId: process.env.REACT_APP_ENV_FIREBASE_MEASUREMENTID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const auth = getAuth(app);
const firestore = getFirestore(app);

export { analytics, app, auth, firestore };
